import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { motion } from "framer-motion";
import { CheckCircle2, XCircle, Loader2 } from "lucide-react";
import api from "../services/api";
import { useAuth } from "../context/AuthContext";

export default function PaymentSuccess() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const { refresh } = useAuth();
  const [status, setStatus] = useState("checking"); // checking | paid | failed
  const sessionId = params.get("session_id");

  useEffect(() => {
    if (!sessionId) {
      setStatus("failed");
      return;
    }
    let tries = 0;
    const poll = async () => {
      try {
        const { data } = await api.get(`/payments/status/${sessionId}`);
        if (data.payment_status === "paid") {
          setStatus("paid");
          if (refresh) refresh();
          return;
        }
      } catch (e) {
        /* ignore */
      }
      tries += 1;
      if (tries < 8) setTimeout(poll, 2000);
      else setStatus("failed");
    };
    poll();
  }, [sessionId]); // eslint-disable-line

  return (
    <div className="min-h-screen flex items-center justify-center p-4 bg-slate-100">
      <motion.div initial={{ scale: 0.85, opacity: 0 }} animate={{ scale: 1, opacity: 1 }} className="w-full max-w-sm rounded-3xl bg-white shadow-xl p-8 text-center">
        {status === "checking" && (
          <>
            <Loader2 className="w-14 h-14 text-indigo-500 mx-auto mb-4 animate-spin" />
            <h2 className="font-display text-2xl font-bold text-slate-800">Confirming your subscription…</h2>
          </>
        )}
        {status === "paid" && (
          <>
            <CheckCircle2 className="w-16 h-16 text-green-500 mx-auto mb-4" />
            <h2 className="font-display text-2xl font-bold text-slate-800 mb-1">You're all set! 🎉</h2>
            <p className="text-slate-500 font-medium mb-5">Your free trial has started. Enjoy Syllaberry Premium!</p>
            <button data-testid="success-continue-btn" onClick={() => navigate("/parent")} className="pop-btn w-full rounded-xl bg-indigo-500 text-white font-bold py-3">Back to Portal</button>
          </>
        )}
        {status === "failed" && (
          <>
            <XCircle className="w-16 h-16 text-red-400 mx-auto mb-4" />
            <h2 className="font-display text-2xl font-bold text-slate-800 mb-1">Hmm, not confirmed yet</h2>
            <p className="text-slate-500 font-medium mb-5">If you completed payment, it may take a moment. You can check your portal.</p>
            <button onClick={() => navigate("/parent")} className="pop-btn w-full rounded-xl bg-slate-700 text-white font-bold py-3">Back to Portal</button>
          </>
        )}
      </motion.div>
    </div>
  );
}
